export default function useLux() {
  const speedcurveLuxState = useState<{ isEnabled: boolean }>('speedcurveLux', () => {
    const origin = useRequestURL().origin;
    const {
      public: { STAGE, speedcurveLux },
    } = useRuntimeConfig();
    const route = useRoute();

    const forceEnable = route.query.forceLux === 'true';
    const isProductionStage = STAGE === 'production';
    const isDev = import.meta.dev && origin.includes('dev.');
    const isEnabled = (speedcurveLux.enabled && isProductionStage && !isDev) || forceEnable;

    return {
      isEnabled,
    };
  });

  const canInteractWithLux = () => speedcurveLuxState.value.isEnabled && import.meta.client && window.LUX;

  return {
    isEnabled: speedcurveLuxState.value.isEnabled,
    addLuxLabel: (label: string) => {
      if (canInteractWithLux()) {
        const LUX = window.LUX || {};
        LUX.label = label;
      }
    },
    addLuxData: (key: string, value: string | number) => {
      if (canInteractWithLux()) {
        const LUX = window.LUX || {};
        LUX?.addData?.(key, value);
      }
    },
  };
}
